module.exports = __webpack_public_path__ + "img/ATG-cust.bc027c45.jpg";